// 付费列表
export const SET_WP_MINE_PAY_LIST = 'SET_WP_MINE_PAY_LIST';
// 壁纸我的
export const SET_WP_MINE_LIST = 'SET_WP_MINE_LIST';
// 壁纸我的收藏
export const GET_WP_COLLECT_LIST = 'GET_WP_COLLECT_LIST';
// 壁纸我的曾用
export const GET_WP_SETUP_LIST = 'GET_WP_SETUP_LIST';
// 壁纸我的订单
export const GET_WP_MINE_PAY_LIST = 'GET_WP_MINE_PAY_LIST';

export const SET_WP_MINE_SETUP_LIST = 'SET_WP_MINE_SETUP_LIST';

export const SET_WP_MINE_COLLECT_LIST = 'SET_WP_MINE_COLLECT_LIST';

export const CANCEL_WP_MINE_COLLECTORSETUP = 'CANCEL_WP_MINE_COLLECTORSETUP';

export const GET_WP_VIP_STATE = 'GET_WP_VIP_STATE';

export const SET_WP_VIP_STATE = 'SET_WP_VIP_STATE';

export const GET_WP_TURN_LIST = 'GET_WP_TURN_LIST';

export const SET_WP_TURN_LOAD = 'SET_WP_TURN_LOAD';

export const SET_WP_TURN_LIST = 'SET_WP_TURN_LIST';

export const CANCEL_MINE_TURN = 'CANCEL_MINE_TURN';

export const GET_WP_GROUP_LIST = 'GET_WP_GROUP_LIST';

export const OPEN_GROUP_LIST = 'OPEN_GROUP_LIST';

export const SET_WP_GROUP_LIST = 'SET_WP_GROUP_LIST';

export const SET_CHOICE_LIST = 'SET_CHOICE_LIST';

export const SET_EQUITY_VIP = 'SET_EQUITY_VIP';

export const WP_IS_NEED_UPDATE_VIP = 'WP_IS_NEED_UPDATE_VIP';

export const SET_SHOW_LIST = 'SET_SHOW_LIST';

export const SET_SHOW_WP_EXCHANGE = 'SET_SHOW_WP_EXCHANGE';

export const GET_WP_EXCHANGE_RESULT = 'GET_WP_EXCHANGE_RESULT';

export const SET_WP_EXCHANGE_RESULT = 'SET_WP_EXCHANGE_RESULT';

export const SET_SHOW_WP_RESULT = 'SET_SHOW_WP_RESULT';
